import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { trackPromise } from 'react-promise-tracker';
import { apiCall } from '../utils/apiUtils';
import { useBrandVoice } from '../contexts/BrandVoiceContext';
import SettingsPanel from './SettingsPanel';

export default function Choose({ change, onResponse, h1Data, setH1Data }) {
    const { getBlogGenerationPayload } = useBrandVoice();

    //iData is initial data, rData is response data
    const handleHeadlineSelect = async (selectedH1) => {
      change();
      onResponse(null, selectedH1, false, 'headline-selected');
    };

    const handleRefresh = async () => {
      try {
         const prompt = {
            trend_topic: h1Data[0], // Using the first trend topic to regenerate
            ...getBlogGenerationPayload()
         };

         const newH1Data = await trackPromise(
            apiCall('/openai-h1', JSON.stringify(prompt))
         );
         
         setH1Data(newH1Data);
      } catch (error) {
         console.error('Error refreshing content:', error);
      }
    };

    const generateButton = h1Data.slice(-5).map((h1, index) => {
      return(
        <div key={index} className="apiCallButton">
          <button onClick={() => handleHeadlineSelect(h1)}>
            <div className="button-flip-container">
              <div className="button-flip-front">
                <div className="button-content">
                  <span className="button-label">{h1}</span>
                </div>
              </div>
              <div className="button-flip-back">
                <svg width="28" height="28" viewBox="0 0 24 24" className="confirm-icon" fill="#fff">
                  <path d="M20.292 5.292a1 1 0 010 1.414l-11 11a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 15.586 18.878 5.708a1 1 0 011.414 0z"/>
                </svg>
              </div>
            </div>
          </button>
        </div>
      )
    })
  
    return(
            <div className='choose-02'>
                <h1>Choose Headline</h1>
                <h2>more headlines? regenerate fast!</h2>
                {generateButton}
                <div className='regenerate-button-container'>
                    <button 
                        onClick={handleRefresh}
                        className='regenerate-icon'
                        title="Regenerate headlines"
                    >
                        <FeatherIcon icon="refresh-cw" width="18px" height="18px" />
                    </button>
                </div>
                <SettingsPanel />
            </div>
        )
}
